import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { ToastrService } from "ngx-toastr";
import { ApiServiceListService } from "src/app/_services/api/api-service-list.service";
import { AuthServiceUser } from "src/app/services/auth/auth.service";
import { CITY_OFFERSLIST, OFFERSLIST } from "src/assets/config/constants";
import { LocalizedString } from "src/app/model/localized-string.model";

@Component({
    selector: "app-offer-section",
    templateUrl: "./offer-section.component.html",
    styleUrl: "./offer-section.component.css",
    standalone: false
})
export class OfferSectionComponent {
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false,
  };
  dropdownSettingsZone = {
    singleSelection: true,
    idField: '_id',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };
  zoneList = [];
  stateList = [];
  cityList = [];
  tableData = [];
  zone: any = {};
  state = "";
  city = "";
  locationScope = "zone";
  dropdownValue = "";

  dropdownOptions = [];
  activeIndex: number | null = null;
  loadref = this.loader.useRef();
  isZoneAdmin = false;

  toggleDropdown(index: number | null, item): void {
    if (index === null) return;

    this.activeIndex = index;
    this.dropdownValue = "";
    this.getOfferSectionGroupData(item);
  }
  currentModuleName = this.route.snapshot.data['module'];
  constructor(
    public loader: LoadingBarService,
    private apiService: ApiServiceListService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private authService: AuthServiceUser
  ) {
    this.breadcrumb = {
      mainlabel: "Offer Management",
    };
    // this.getOfferSectionData();
    const currentUser = this.authService.getUserInfo();
    if (currentUser.role?.includes('zoneadmin')) {
      this.zone = currentUser.zone;
      this.isZoneAdmin = true;
      this.getOfferSectionData();
    } else {
      this.getZonesList();
      this.getStatesList();
    }

  }

  getOfferSectionGroupData(data) {
    this.loadref.increment(35);
    const payload = {
      page: [data.page],
      locationScope: this.locationScope,
      zone: this.zone?._id || "",
      city: this.city || "",
    };
    this.apiService.getOfferSectionGroup(payload).subscribe({
      next: (value: any) => {
        // Handle emitted values
        if (value.data) {
          // this.tableData = value.data;
          this.dropdownOptions = value.data;
        } else {
          this.tableData = [];
        }
      },
      error: (error: any) => {
        // Handle errors
      },
      complete: () => {
        this.loadref.complete();
      },
    });
  }

  getOfferSectionData() {
    this.loadref.increment(35);
    const payload = {
      locationScope: this.locationScope,
      zone: this.zone?._id || "",
      city: this.city || "",
    };
    this.apiService.getOfferSection(payload).subscribe({
      next: (value: any) => {
        // Handle emitted values
        if (value.success) {
          this.tableData = this.mergeValues(value.data);
        } else {
          this.tableData = [];
        }
        this.loadref.complete();
      },
      error: (error: any) => {
        // Handle errors
        this.loadref.complete();
      }
    });
  }


  getZonesList() {
    this.apiService.getZonesList().subscribe(
      {
        next: (response: any) => {
          this.zoneList = response.data;
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }

  getStatesList() {
    this.apiService.getStatesList().subscribe({
      next: (response: any) => {
        this.stateList = response?.data || [];
      },
      error: (err) => console.log(err)
    });
  }

  getCitiesList(stateId: string = "") {
    if (!stateId) {
      this.cityList = [];
      return;
    }
    this.apiService.getCitiesList(stateId).subscribe({
      next: (response: any) => {
        this.cityList = response?.data || [];
      },
      error: (err) => console.log(err)
    });
  }

  zoneChange(event) {
    console.log(event);
    this.zone = event;
    this.getOfferSectionData();
  }

  scopeChange() {
    this.tableData = [];
    this.activeIndex = null;
    if (this.locationScope === "zone" && this.zone?._id) {
      this.getOfferSectionData();
    }
  }

  stateChange() {
    this.city = "";
    this.getCitiesList(this.state);
  }

  cityChange() {
    this.getOfferSectionData();
  }
  saveOfferSectionDetail(item) {
    console.log(item);
    if (!this.dropdownValue) {
      this.toastr.error("Please select offer", "", {
        timeOut: 3000,
      });
      return;
    }

    const selectedValue = this.dropdownOptions.find(
      (x) => x._id == this.dropdownValue
    );

    let body = {
      _id: item._id,
      page: item.page,
      section: item.section,
      title: selectedValue.title,
      offerGroup: selectedValue._id,
      locationScope: this.locationScope,
      zone: this.zone?._id || "",
      city: this.city || "",
    };
    this.loadref.increment(35);
    this.apiService.updateOfferSection(body).subscribe({
      next: (response: any) => {
        // Handle emitted values
        this.toastr.success(response.message, "", {
          timeOut: 3000,
        });
        this.activeIndex = null;
        this.getOfferSectionData();
        this.loadref.complete();
      },
      error: (error: any) => {
        // Handle errors
        this.toastr.error(error.message, "", {
          timeOut: 3000,
        });
        this.loadref.complete();
      }
    });
  }


  mergeValues(dataValues) {
    const constantValues = JSON.parse(JSON.stringify(this.locationScope === "city" ? CITY_OFFERSLIST : OFFERSLIST));
    const dataMap = new Map();
    dataValues.forEach(item => {
      const key = `${item.page}_${item.section}`;
      dataMap.set(key, item);
    });

    const updatedValues = constantValues.map(item => {
      const key = `${item.page}_${item.section}`;
      const matchingItem = dataMap.get(key);

      return matchingItem
        ? { ...item, _id: matchingItem._id, title: matchingItem.title, updatedAt: matchingItem.updatedAt, updatedBy: matchingItem.updatedBy, createdBy: matchingItem.createdBy }
        : item;
    });

    return updatedValues;
  }

  offerSectionClearModal(modal, item) {
    this.modalService
      .open(modal, {
        ariaLabelledBy: "modal-basic-title",
        keyboard: false,
        backdrop: "static",
        size: "sm",
        centered: true,
      })
      .result.then(
        (result) => {
          console.log("self.selectObj", result);
          if (result == "Ok click") {
            this.clearOfferSelection(item);
          }
        },
        (_) => {
          console.log("close");
        }
      );
  }

  clearOfferSelection(item) {
    let body = {
      _id: item._id,
    };
    this.loadref.increment(35);
    this.apiService.clearOfferSection(body).subscribe({
      next: (response: any) => {
        // Handle emitted values
        this.toastr.success(response.message, "", {
          timeOut: 3000,
        });
        this.activeIndex = null;
        this.getOfferSectionData();
        this.loadref.complete();
      },
      error: (error: any) => {
        // Handle errors
        this.toastr.error(error.message, "", {
          timeOut: 3000,
        });
        this.loadref.complete();
      }
    });
  }

  getLocalizedText(value: any): string {
    const localized = this.normalizeLocalizedString(value);
    return localized.en || localized.te || "";
  }

  private normalizeLocalizedString(value: any): LocalizedString {
    if (!value) {
      return { en: "", te: "" };
    }
    if (typeof value === "string") {
      return { en: value, te: "" };
    }
    return {
      en: value.en || "",
      te: value.te || "",
    };
  }
}
